import { render, staticRenderFns } from "./04Statements.vue?vue&type=template&id=63c8c9f8&"
import script from "./04Statements.vue?vue&type=script&lang=js&"
export * from "./04Statements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports